import React, { ChangeEvent, useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    DraggerWrapper,
    InputWrapper,
    ItemButton,
    ItemWrapper, MarketTemplateSelectionForm,
    TemplateOptionsDropDown, VerticalMoveIconWrapper
} from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSettings.style';
import Icon from 'src/components/Icon/Icon';
import { Checkbox } from 'src/components/MarketTemplateSettingsForm/FormComponents/MarketTemplateInputs';
import { SelectionNewTradingType } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSelections';
import { MarketTemplateSelectionNewTradingState } from 'src/components/MarketTemplateSettingsForm/Components/MarketTemplateSelectionNewTrading.state';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';
import { MarketTemplateSettingsFormState } from 'src/components/MarketTemplateSettingsForm/MarketTemplateSettingsForm.state';
import { SportMarketTemplatesState } from 'src/components/SportPopup/SportMarketTemplates/SportMarketTemplates.state';

export type MarketTemplateSelectionSettingsNewTradingPropsType = {
    selection: SelectionNewTradingType;
    isDragged: boolean;
    marketTemplateSettingsState: MarketTemplateSettingsFormState;
    marketTemplateState: SportMarketTemplatesState;
}

export const MarketTemplateSelectionSettingsNewTrading = observer('MarketTemplateSelectionSettingsNewTrading', (props: MarketTemplateSelectionSettingsNewTradingPropsType) => {
    const [stateMap] = useState(new MobxMapAutoNew(
        (selection: SelectionNewTradingType) => new MarketTemplateSelectionNewTradingState(selection, props.marketTemplateSettingsState, props.marketTemplateState)
    ));
    const state = stateMap.get(props.selection);

    return (
        <ItemWrapper>
            <InputWrapper>
                <div className='element'>
                    <input type='text' value={state.inputState.value ?? ''} onBlur={state.onSelectionNameChange} onChange={state.onEditName}/>
                    <span className='element-help' title='title="You can use the following placeholders in name ${player} ${homesubparticipant} ${awaysubparticipant} ${home} ${away} ${line} ${opposite-line}"'>
                        <span className='icon icon--info css-1krtr0r-SpanWrapper'></span>
                    </span>
                </div>
            </InputWrapper>
            <TemplateOptionsDropDown>
                <a
                    href='#'
                    className='btn'
                    onClick={state.toggleSelection}
                >
                    <Icon name='cog' />
                </a>
            </TemplateOptionsDropDown>
            <DraggerWrapper>
                <ItemButton
                    isDragged={props.isDragged}
                    data-movable-handle
                    tabIndex={-2}
                >
                    <VerticalMoveIconWrapper />
                </ItemButton>
            </DraggerWrapper>
            {
                state.openedSelections.includes(props.selection.namePattern ?? '') ?
                    <MarketTemplateSelectionForm>
                        <Checkbox
                            dataTest={`selections.${props.selection.namePattern}.autoCreate`}
                            label='Automatically add selection with market'
                            name='autoCreate'
                            checked={props.selection.autoCreate}
                            onSave={state.onChangeAutoCreate}
                        />
                        <table>
                            <thead>
                                <tr>
                                    <th>Tag name</th>
                                    <th>Value</th>
                                </tr>
                            </thead>
                            {
                                props.marketTemplateState.getTags === 'loading' ?
                                    <h2>Loading</h2> :
                                    <tbody>
                                        {
                                            state.tagsForSelections.length > 0 ?
                                                state.tagsForSelections.map(tag => {
                                                    const key = Object.keys(tag)[0];
                                                    const details = tag[key ?? 0];

                                                    if ( details === undefined || key === undefined ) {
                                                        return null;
                                                    }

                                                    const selected = Object.entries(props.selection.metadata).find(item => item[0] === key);
                                                    const selectedKey = selected && selected?.length > 0 ? selected[1] : undefined;
                                                    return (<tr key={ key }>
                                                        <td>{ details.label }</td>
                                                        <td>
                                                            <div className='element'>
                                                                <div className='select-wrapper'>
                                                                    <select onChange={(e: ChangeEvent<HTMLSelectElement>) => state.onTagChange(e.target.value, key) } defaultValue={selectedKey}>
                                                                        <option/>
                                                                        {
                                                                            details.values.map(item => <option key={key + item.id} value={item.id} >{item.label}</option>)
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>);
                                                }) : null
                                        }
                                    </tbody>
                            }

                        </table>
                    </MarketTemplateSelectionForm> : null
            }
        </ItemWrapper>

    );
});
